module.exports = __webpack_public_path__ + "static/blueberry-logo-0965a4fcf4f0b23e53d7551db0f53a05.jpeg";